import {
  CVS_PHARMACY_DESCRIPTION_1,
  WALMART_PHARMACY_DESCRIPTION_1,
  DEFAULT_ERR,
  WALMART_PHARMACY_DESCRIPTION_2
} from '../../constants/defaults';
const ConstantEn = {
  CVS_PHARMACY_DESCRIPTION_1: CVS_PHARMACY_DESCRIPTION_1,
  WALMART_PHARMACY_DESCRIPTION_1: WALMART_PHARMACY_DESCRIPTION_1,
  DEFAULT_ERR: DEFAULT_ERR,
  WALMART_PHARMACY_DESCRIPTION_2: WALMART_PHARMACY_DESCRIPTION_2
};
export default ConstantEn;
